module.exports = __webpack_public_path__ + "img/wxxcx.c8cbf075.jpg";